import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=82c261a2&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&id=82c261a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c261a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82c261a2')) {
      api.createRecord('82c261a2', component.options)
    } else {
      api.reload('82c261a2', component.options)
    }
    module.hot.accept("./ContentHeader.vue?vue&type=template&id=82c261a2&scoped=true", function () {
      api.rerender('82c261a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Header/ContentHeader.vue"
export default component.exports